// extracted by mini-css-extract-plugin
export default {"productDescription":"Qaa-z","featuredDescription":"Raa-z","description":"Saa-z","more":"Taa-z","descriptionSku":"Uaa-z"};